import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import ListSubheader from '@material-ui/core/ListSubheader';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Collapse from '@material-ui/core/Collapse';
import Contenido from './Contenido';
import ReactDOM from 'react-dom';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    maxWidth: 250,
    backgroundColor: theme.palette.background.paper,
  },
  nested: {
    paddingLeft: theme.spacing(4),
  },
}));

export default function Menu() {
  const classes = useStyles();
  const [open, setOpen] = React.useState(true);

  const handleClick = () => {
    setOpen(!open);
  };

  const showComponent = (contenido) =>{
    ReactDOM.render(<Contenido/>, document.getElementById('CompWiki'));
  }

  return (
    <List
      component="nav"
      aria-labelledby="nested-list-subheader"
      subheader={
        <ListSubheader component="div" id="nested-list-subheader">
          Componentes
        </ListSubheader>
      }
      className={classes.root}
    >
      <ListItem button>
        <ListItemText primary="Componente 1" onClick={() => showComponent('Contenido') } />
      </ListItem>
      <ListItem button>
        <ListItemText primary="Componente 2"/>
      </ListItem>
      <ListItem button>
        <ListItemText primary="Componente 3"/>
      </ListItem>
    </List>
  );
}